import axios from 'axios'

// API 基础 URL 配置
// 开发环境使用代理（空字符串），生产环境使用当前域名
const isDevelopment = process.env.NODE_ENV === 'development'
export const SHARE_URL = isDevelopment 
  ? ''  // 开发环境：使用代理，请求本地路径e
  : window.location.origin  // 生产环境：当前域名

export const OAUTH_URL2 = 'https://pro-saas-one.aishare.icu/'  // 固定地址
export const OAUTH_URL1 = 'https://pro-saas-one.shareplus.icu/'  // 固定地址
export const OAUTH_URL = 'https://pro.aishare.icu/'  // 新PLUS站点地址

// export const OAUTH_URL = 'http://127.0.0.1:5097/'  // 固定地址
// export const OAUTH_URL = 'http://47.252.52.233:5097'  // 固定地址



// 打印当前配置（便于调试）
console.log('🔧 API 配置信息:')
console.log('环境:', process.env.NODE_ENV)
console.log('SHARE_URL:', SHARE_URL || '使用代理 (http://localhost:8080 → https://node1.shareplus.icu/)')
console.log('OAUTH_URL:', OAUTH_URL)
if (isDevelopment) {
  console.log('📡 开发环境代理: /frontend-api/* → https://node1.shareplus.icu/frontend-api/*')
}

// 创建 axios 实例 - SHARE API
export const shareAxios = axios.create({
  baseURL: SHARE_URL,
  timeout: 15000,
  withCredentials: true, // 允许携带 Cookie
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

// 创建 axios 实例 - OAUTH API
export const oauthAxios = axios.create({
  baseURL: OAUTH_URL,
  timeout: 10000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

// SHARE API 请求拦截器
shareAxios.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// SHARE API 响应拦截器
shareAxios.interceptors.response.use(
  response => {
    // 直接返回响应数据
    return response.data
  },
  error => {
    // 详细的错误处理
    if (error.response) {
      // 服务器返回了错误状态码
      console.error('API错误:', error.response.status, error.response.data)
    } else if (error.request) {
      // 请求已发送但没有收到响应
      console.error('网络错误: 无法连接到服务器')
    } else {
      // 请求配置出错
      console.error('请求配置错误:', error.message)
    }
    return Promise.reject(error)
  }
)

// OAUTH API 请求拦截器
oauthAxios.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// OAUTH API 响应拦截器
oauthAxios.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)




